import React from 'react';
import PropTypes from 'prop-types';
import AuthRoute from './authRoute';
import useAppContext from '../context/useAppContext';
import PageError from '../pages/error/pageError';

export default function AuthRouteEvent({ allow = [], path = '', children = null, fallback = null, ...routeProps }) {
    const [{ organization, event }] = useAppContext();

    const backHomeUrl = React.useMemo(() => {
        if (!organization) {
            return null;
        }

        if (!event) {
            return `/ticket/O${organization.id}/events`;
        }

        return `/ticket/O${organization.id}/E${event.id}/dashboard`;
    }, [organization, event]);

    return (
        <AuthRoute allow={allow} path={path} fallback={fallback || <PageError errorCode={403} backHomeUrl={backHomeUrl} />} {...routeProps}>
            {children}
        </AuthRoute>
    );
}

AuthRouteEvent.propTypes = {
    allow: PropTypes.array,
    path: PropTypes.string,
    fallback: PropTypes.node,
    children: PropTypes.node
};
